import {
  IS_IN_PROGRAMME_LIST_ERROR,
  IS_IN_PROGRAMME_LIST_REQUEST,
  IS_IN_PROGRAMME_LIST_REQUEST_RECEIVED,
  MY_PREFERRED_PROGRAMMES_ERROR,
  PREFERRED_PROGRAMMES_RECEIVED,
  PREFERRED_PROGRAMMES_REQUEST,
  UNLOAD_MY_PREFERRED_PROGRAMMES,
} from "./types";

export const preferredProgrammes = (
  state = {
    preferredProgramme: {},
    isInProgramme: [],
    isFetchingProgramme: false,
    error: false,
    errorData: {},
  },
  action
) => {
  switch (action.type) {
    case IS_IN_PROGRAMME_LIST_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: false,
      };
    case IS_IN_PROGRAMME_LIST_REQUEST_RECEIVED:
      return {
        ...state,
        isFetchingProgramme: false,
        isInProgramme: action.data ? action.data : [],
        error: false,
      };
    case IS_IN_PROGRAMME_LIST_ERROR:
      return {
        ...state,
        isFetchingProgramme: false,
        errorData: action.data.error,
        error: true,
      };
    default:
      return state;
  }
};

export const myPreferredProgrammes = (
  state = {
    myPreferredProgrammes: [],
    isFetchingPreferredProgrammes: false,
    error: false,
  },
  action
) => {
  switch (action.type) {
    case PREFERRED_PROGRAMMES_REQUEST:
      return {
        ...state,
        isFetchingPreferredProgrammes: true,
      };
    case PREFERRED_PROGRAMMES_RECEIVED:
      return {
        ...state,
        myPreferredProgrammes: action.data ? action.data : [],
        error: false,
        isFetchingPreferredProgrammes: false,
      };
    case MY_PREFERRED_PROGRAMMES_ERROR:
      return {
        ...state,
        isFetchingPreferredProgrammes: false,
        error: true,
        myPreferredProgrammes: [],
      };
    case UNLOAD_MY_PREFERRED_PROGRAMMES:
      return {
        ...state,
        isFetchingPreferredProgrammes: false,
        error: false,
        myPreferredProgrammes: [],
      };
    default:
      return state;
  }
};
